/**
 * 将 pay_config.qr_code 转为可扫码的二维码图片（data URL）
 */
import QRCode from 'qrcode'

/** 已是图片地址 / data URL 时直接返回，否则返回 null 表示需编码成二维码 */
export function getPayQrDirectImageSrc(qrCode) {
  const raw = qrCode == null ? '' : String(qrCode).trim()
  if (!raw) return ''
  if (/^data:image\//i.test(raw)) return raw
  if (/^https?:\/\//i.test(raw) && /\.(png|jpg|jpeg|gif|webp|bmp)(\?|#|$)/i.test(raw)) {
    return raw
  }
  if (raw.length > 200 && /^[A-Za-z0-9+/=\s]+$/.test(raw)) {
    return `data:image/png;base64,${raw.replace(/\s/g, '')}`
  }
  return null
}

/**
 * 把支付串 / 链接编码为二维码 PNG（base64 data URL）
 * @param {string} qrCode pay_config.qr_code
 * @param {{ width?: number }} [opts]
 * @returns {Promise<string>}
 */
export async function generatePayQrDataUrl(qrCode, opts = {}) {
  const raw = qrCode == null ? '' : String(qrCode).trim()
  if (!raw) return ''

  const direct = getPayQrDirectImageSrc(raw)
  if (direct) return direct

  const width = opts.width || 240
  return QRCode.toDataURL(raw, {
    width,
    margin: 2,
    errorCorrectionLevel: 'M',
    type: 'image/png',
    color: {
      dark: '#000000ff',
      light: '#ffffffff'
    }
  })
}
